import * as React from 'react';
import * as _ from 'lodash';

import TextScreenModal from 'login-components/Common/TextScreenModal/TextScreenModal';
import Checkbox from '../CheckboxInput/CheckboxInput';
import { AcceptedTermsTypes, getSeparatedDisplayPartsFromAcceptedTermsTypes } from './utils';

namespace RequirementInput {
  export interface Props extends InputProps {
    acceptedTermsTypes: AcceptedTermsTypes[];
  }

  export interface State {
    modalOpen: boolean;
    headerText: string;
    textScreenId: string;
  }
}

// TODO (UI-5074): Consider making some of this common
// A wrapping component of CheckboxInput that makes it easier to generate checkboxes in the form of
// "I confirm that I have read and agree to [insert valid links to modals here]."
class RequirementInput extends React.PureComponent<RequirementInput.Props, RequirementInput.State> {
  state = {
    modalOpen: false,
    headerText: '',
    textScreenId: '',
  };

  openModal = (textScreenId: string, headerText: string) => {
    this.setState({
      modalOpen: true,
      headerText,
      textScreenId,
    });
  };

  dismissModal = () => {
    this.setState({ modalOpen: false });
  };

  generateDisplayParts = (): Checkbox.Props['displayParts'] => {
    const { acceptedTermsTypes } = this.props;
    const linksDisplay = getSeparatedDisplayPartsFromAcceptedTermsTypes(acceptedTermsTypes, this.openModal);
    return ['I confirm that I have read and agree to the ', ...linksDisplay, '.'];
  };

  render() {
    const {
      acceptedTermsTypes: _acceptedTermsTypes,
      hidePlaceholder: _hidePlaceholder,
      identifier: _identifier,
      ...inputProps
    } = this.props;
    const { modalOpen, headerText, textScreenId } = this.state;

    return (
      <React.Fragment>
        <Checkbox
          {...inputProps}
          identifier={_.get(inputProps, 'input.name', 'Checkbox')}
          displayParts={this.generateDisplayParts()}
        />
        {modalOpen && (
          <TextScreenModal
            data-it="RequirementInput-TextScreenModal"
            textScreenId={textScreenId}
            headerText={headerText}
            contentLabel="Help Dialog"
            isOpen={modalOpen}
            handleClose={this.dismissModal}
          />
        )}
      </React.Fragment>
    );
  }
}

export const RequirementInputConfig = {
  component: RequirementInput,
};

export default RequirementInput;
